export interface InitState {
  inited: boolean
  musicInfo: AnyListen.Player.MusicInfo
  playMusicInfo: AnyListen.Player.PlayMusicInfo | null
  playInfo: AnyListen.Player.PlayInfo
  playerPlaying: boolean
  playing: boolean
  statusText: string
  title: string | null
  loadErrorPicUrl: string
  progress: {
    nowPlayTime: number
    maxPlayTime: number
    progress: number
    nowPlayTimeStr: string
    maxPlayTimeStr: string
  }
  playList: AnyListen.Player.PlayMusicInfo[]
  volume: number
  volumeMute: boolean
  playbackRate: number
  isPlayedStop: boolean
  dislikeIds: Set<string>
  playHistoryList: AnyListen.IPCPlayer.PlayHistoryListItem[]
}

// const empty = {}
export const playerState: InitState = {
  inited: false,
  musicInfo: {
    id: null,
    pic: undefined,
    lrc: null,
    tlrc: null,
    rlrc: null,
    awlrc: null,
    rawlrc: null,
    name: '',
    singer: '',
    album: '',
    collect: false,
  },
  playMusicInfo: null,
  playInfo: {
    duration: 0,
    index: -1,
    listId: '',
    historyIndex: -1,
    lastTrackId: null,
    source: 'local',
    isLinkedList: false,
  },
  playerPlaying: false,
  playing: false,
  statusText: '',
  title: null,
  loadErrorPicUrl: '',
  progress: {
    nowPlayTime: 0,
    maxPlayTime: 0,
    progress: 0,
    nowPlayTimeStr: '00:00',
    maxPlayTimeStr: '00:00',
  },
  playList: [],
  volume: 0,
  volumeMute: false,
  playbackRate: 1,
  isPlayedStop: false,
  dislikeIds: new Set(),
  playHistoryList: [],
}
